import { render, staticRenderFns } from "./SchedulerOrdersTable.vue?vue&type=template&id=0c8eb3c9"
import script from "./SchedulerOrdersTable.vue?vue&type=script&lang=js"
export * from "./SchedulerOrdersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports